import React from 'react'

import { colors as zetColors } from '@zet/design-system'
import { Icon } from '@zet/design-system/icons'
import { Stack, XStack } from '@zet/design-system/layout'
import { SH3 } from '@zet/design-system/typography'
import { i18n } from '@zet/localization'

type LeadPartlyFulFilledProps = {
  item?: object
}

const LeadPartlyFulFilled = ({ item }: LeadPartlyFulFilledProps) => {
  return (
    <Stack className="border-grays-30 bg-neutral-white100 mt-2 rounded-sm border-l-4 pb-2">
      <XStack className="py-4/2 px-3">
        <Stack className="bg-success-8 absolute left-[30] h-4 w-1" />
        <Stack className="bg-success-8 absolute left-3 top-3 items-center rounded-lg">
          <Icon
            type={'DoneOutlined'}
            size={20}
            color={zetColors.success[100]}
            className="m-1.5"
          />
        </Stack>
        <Stack className="left-6 mt-2 justify-center">
          <SH3 className=" text-grays-60">
            {i18n.t('leads.salePartlyComplete')}
          </SH3>
        </Stack>
      </XStack>
    </Stack>
  )
}

export default LeadPartlyFulFilled
